export default "__VITE_PUBLIC_ASSET__fe736ee8__"